import Vue from 'vue'
import Vuex from 'vuex'
// import createLogger from 'vuex/dist/logger'

import auth from './auth'
import common from './common'
import esrnCommon from './esrn/common'
import schoolFood from './schoolFood'
import schoolFoodListPerson from './schoolFoodListPerson'
import kgChildrenList101 from './kindergarten_101/kgChildrenList101'
// import kgreestr101 from './kindergarten_101/kgreestr101'
import gisGmpCharge from './gis_gmp/charge'
import gisGmpChargeForPreparation from './gis_gmp/chargeForPreparation'
import gisGmpPayer from './gis_gmp/payer'
import gisExportPayment from './gis_gmp/exportPayment'
import gisGmpPackage from './gis_gmp/package'
import gisGmpReferenceTables from './gis_gmp/reference_tables'
import gisGmpForcedAcknowledgement from './gis_gmp/forcedAcknowledgement'
import gisGmpReports from './gis_gmp/reports'

import files from './gku_reestr/files'
import gkuReceipts from './gku_reestr/receipts'
import ASSoftware from './accounting_software/software'
import ASDocument from './accounting_software/document'
import ASReports from './accounting_software/reports'
import hemodialysisPerson from './hemodialysis/person'
import hemodialysisService from './hemodialysis/service'

import reportingReport from './reporting/report'
import kindergartenRegistries from './kindergarten/registries'

// const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    modules: {
      auth,
      common: common,
      esrn_common: esrnCommon,
      schoolFood,
      schoolFoodListPerson,
      gis_gmpCharge: gisGmpCharge,
      gis_gmpPayer: gisGmpPayer,
      gis_gmpExportPayment: gisExportPayment,
      gis_gmpChargeForPreparation: gisGmpChargeForPreparation,
      gis_gmpPackage: gisGmpPackage,
      gis_gmpReferenceTables: gisGmpReferenceTables,
      gis_gmpForcedAcknowledgement: gisGmpForcedAcknowledgement,
      gis_gmpReports: gisGmpReports,
      files,
      gku_receipts: gkuReceipts,
      // kgreestr101,
      kgChildrenList101,
      ASSoftware,
      ASDocument,
      ASReports,
      hemodialysisPerson,
      hemodialysisService,
      reportingReport,
      kindergartenRegistries
    }
    // strict: debug,
    // plugins: debug ? [createLogger()] : []
  }
)
